/* eslint-disable react/no-array-index-key */
import React from 'react'
import PropTypes from 'prop-types'
import { t } from '@lingui/macro'
import WhatIsYoti from '../../../components/WhatIsYoti'
import TrustedBy from '../../../components/TrustedBy'
import whatIsYotiCompany from '../../../../assets/what-is-yoti-company.png'
import DeviceStoreIcons from '../../../components/DeviceStoreIcons'
import LocalisedImage from '../../../components/common/LocalisedImage'

import './CompanySection.scss'

const Image = ({ imgSrc, parentClass, ...props }) => (
  <div className={`${parentClass}__image`}>
    <LocalisedImage src={imgSrc} {...props} alt={t`What is Yoti`} />
  </div>
)

Image.propTypes = {
  imgSrc: PropTypes.string.isRequired,
}

const Company = ({ device }) => (
  <div className="company">
    <div className="company__container">
      <div className="company__container__description">
        <WhatIsYoti />
        <DeviceStoreIcons device={device} />
      </div>
      <div className="company__container__visual">
        <Image parentClass="company__container__visual" imgSrc={whatIsYotiCompany} />
      </div>
      <div className="company__container__trust">
        <TrustedBy />
      </div>
    </div>
  </div>
)

Company.propTypes = {
  device: PropTypes.objectOf(PropTypes.any).isRequired
}

export default Company
